import { createAction, props } from '@ngrx/store';
import { FeatureCollection } from 'geojson';

export const saveMasterplanFeatures = createAction(
  '[Simulation Masterplan Feature] Save Features',
  props<{ explorer_project_uuid: string; geojson: FeatureCollection,simulationName: string, masterplan_uuid?: string }>()
);

export const saveMasterplanFeaturesSuccess = createAction(
  '[Simulation Masterplan Feature] Save Features Success'
);

export const saveMasterplanFeaturesFailure = createAction(
  '[Simulation Masterplan Feature] Save Features Failure',
  props<{ error: any }>()
);
export const saveAndStartSimulation = createAction(
    '[Simulation Masterplan Feature] Save and Start Simulation',
    props<{ explorer_project_uuid: string; geojson: FeatureCollection; name:string; layers: string[], masterplan_uuid?: string }>()
  );
  
  
  export const saveAndStartSimulationSuccess = createAction(
    '[Simulation Masterplan Feature] Save and Start Simulation Success'
  );
  
  export const saveAndStartSimulationFailure = createAction(
    '[Simulation Masterplan Feature] Save and Start Simulation Failure',
    props<{ error: any }>()
  );
  export const uploadShapefileZip = createAction(
  '[Simulation Masterplan Feature] Upload Shapefile Zip',
  props<{ file: File }>()
);

export const uploadShapefileZipSuccess = createAction(
  '[Simulation Masterplan Feature] Upload Shapefile Zip Success',
  props<{ geojson: FeatureCollection; bbox?: number[]; warnings?: string[] }>()
);

export const uploadShapefileZipFailure = createAction(
  '[Simulation Masterplan Feature] Upload Shapefile Zip Failure',
  props<{ error: any }>()
);
export const resetUploadState = createAction('[Simulation Masterplan Feature] Reset Upload');



 export const uploadShapefileSimulationAreaZip = createAction(
  '[Simulation Masterplan Feature] Upload Shapefile Simulation Area Zip',
  props<{ file: File }>()
);

export const uploadShapefileSimulationAreaZipSuccess = createAction(
  '[Simulation Masterplan Feature] Upload Shapefile Simulation Area Zip Success',
  props<{ geojson: FeatureCollection; bbox?: number[]; warnings?: string[] }>()
);

export const uploadShapefileSimulationAreaZipFailure = createAction(
  '[Simulation Masterplan Feature] Upload Shapefile Simulation Area Zip Failure',
  props<{ error: any }>()
);

export const resetUploadSimulationAreaState = createAction('[Simulation Masterplan Feature] Reset Upload');